export default {
	userRoles: [],
	objRoleEdit: [],
	objRolePlists: [],
	objManuPlists: [],
	objRolePrivs: [],
	objLinkedStatus: [],
	tabs:[],
}
